<script>
import { productBrandService } from "../../services";
import { required , requiredIf, email} from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";
import DropzonePopup from "../../components/widgets/dropzone-popup";

export default {
  components: { productBrandService, DropzonePopup},
    data() {
        return {
            checked: true,
            url: null,
            config: config,
            typeform: {
                name: "",
                name_lang: "",
                image:"",
                company_name:"",
                status: "1",
                street_no: "",
                street: "",
                city: "",
                postalcode: "",
            },
        };
    },
    validations: {
        typeform: {
            name:{
                required,
            },
            name_lang: {
                required
            },
            image:{
                required,
            },
            company_name:{
                required,
            },
            city:{
                required,
            },
            postalcode:{
                required,
            },
            street:{
                required,
            },
            street_no:{
                required,
            }
        },
    },
    methods: {
        alphabetic(e){   
            const floating = /^[A-Za-z ]+$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        contactNumber(evt) {
            let val1 = evt.target.value;
            if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
                evt.preventDefault();
            }
            let partlen = val1.split("+").length - 1;
            if (evt.keyCode == 43 && partlen > 0) {
                evt.preventDefault();
            } else if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
                evt.preventDefault();
            }
        },
        addproductBrand(){
            this.$v.typeform.$touch();
            if (this.$v.typeform.$invalid) {
                // error_message(this.trans.get('__JSON__.Please add all required fields'));
                setTimeout(()=>{
                    $('html, body').animate({
                        scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
                    }, 200, function() {
                        $(".is-invalid:first").focus();
                    });
                },300);
                return;
            } else {
                productBrandService.addproductBrand(this.typeform).then((response) => {
                    if (response.data.code === 200) {
                        success_message(response.data.message);
                        this.$router.push({ name: "product-brand-list" });
                    } else {
                        error_message(response.data.message);
                    }
                });
            }
        },
    },
};

</script>
<template>
    <form @submit.prevent="addproductBrand">
        <div class="card">
            <div class="card-body">
                 <h4 class="card-title">{{ trans.get('__JSON__.Brand Information') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">

                    <div class="col-sm-6" v-if="$auth.setting">
                        <div class="form-group">
                           <label class="required">{{ trans.trans('__JSON__.Brand Name Primary',{ lang: $auth.langauges[0].name })}}</label>
                            <input
                                id="name"
                                v-model="$v.typeform.name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Brand Name Primary',{ lang: $auth.langauges[0].name })"
                                name="name"
                                :class="{ 'is-invalid': $v.typeform.name.$error }"
                            />
                            <div v-if="$v.typeform.name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.name.required">{{ trans.get('__JSON__.Please enter brand name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6" v-if="$auth.langauges[1].name !== 'No Secondary Language'">
                        <div class="form-group">
                           <label class="required">{{ trans.trans('__JSON__.Brand Name Secondary',{ lang: $auth.langauges[1].name })}}</label>
                            <input
                                id="name_lang"
                                v-model="$v.typeform.name_lang.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Brand Name Secondary',{ lang: $auth.langauges[1].name })"
                                name="name_lang"
                                :class="{ 'is-invalid': $v.typeform.name_lang.$error }"
                            />
                            <div v-if="$v.typeform.name_lang.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.name_lang.required">{{ trans.get('__JSON__.Please enter brand name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                           <label class="required">{{ trans.trans('__JSON__.Image')}}</label>
                            <dropzone-popup
                                v-model="$v.typeform.image.$model"
                                type="file"
                                id="image"
                                name="image"
                                acceptedFiles=".jpeg,.jpg,.png"
                            />
                            <div v-if="$v.typeform.image.$error" class="invalid-feedback cuisine-img">
                            <span v-if="!$v.typeform.image.required" >{{ trans.get('__JSON__.Please select image') }}.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Producer Information') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Company Name')}}</label>
                            <input
                                id="company_name"
                                v-model="$v.typeform.company_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Company Name')"
                                name="company_name"
                                :class="{ 'is-invalid': $v.typeform.company_name.$error }"
                            />
                            <div v-if="$v.typeform.company_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.company_name.required">{{ trans.get('__JSON__.Please enter company name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street')}}</label>
                            <input
                                id="street"
                                v-model="$v.typeform.street.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street')"
                                name="street"
                                v-on:keypress="alphabetic($event,typeform.street)"
                                :class="{ 'is-invalid': $v.typeform.street.$error }"
                            />
                            <div v-if="$v.typeform.street.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.street.required">{{ trans.get('__JSON__.Please enter street name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street Number')}}</label>
                            <input
                                maxlength="5"
                                minlength="1"
                                id="street_no"
                                v-model="$v.typeform.street_no.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street Number')"
                                name="street_no"
                                :class="{ 'is-invalid': $v.typeform.street_no.$error }"
                            />
                            <div v-if="$v.typeform.street_no.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.street_no.required">{{ trans.get('__JSON__.Please enter street number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.City')}}</label>
                            <input
                                id="city"
                                v-model="$v.typeform.city.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.City')"
                                name="city"
                                v-on:keypress="alphabetic($event,typeform.city)"
                                :class="{ 'is-invalid': $v.typeform.city.$error }"
                            />
                            <div v-if="$v.typeform.city.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.city.required">{{ trans.get('__JSON__.City Name Error') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Postal Code')}}</label>
                            <input
                                maxlength="10"
                                minlength="3"
                                id="postalcode"
                                v-model="$v.typeform.postalcode.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Postal Code')"
                                name="postalcode"
                                :class="{ 'is-invalid': $v.typeform.postalcode.$error }"
                            />
                            <div v-if="$v.typeform.postalcode.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.postalcode.required">{{ trans.get('__JSON__.Please enter postal code') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Add Product Brand') }}</button>
                        <!-- <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button> -->
                        <router-link
                            :to="{name:'product-brand-list'}"
                        >
                            <b-button 
                                type="button" 
                                variant="secondary" 
                                class="mt-3">   
                                {{ trans.get('__JSON__.Cancel') }}
                            </b-button>
                        </router-link>    
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>